<app-dynamic-form [(form)]="form" [questions]="questions"></app-dynamic-form>
